import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import { Switch, Row, message, TreeSelect, Radio, Input, Col, Spin } from "antd";
import Modal from "antd/lib/modal/Modal";
import parse from "html-react-parser";
import "./EncryptModal.css";

const { SHOW_PARENT } = TreeSelect;
const HEALTH_FORM_BASE_URL = "https://mobile.beclutch.club/uploads/camper/";

const resolveHealthFormUrl = (camperRecord) => {
  if (!camperRecord) return null;

  const raw = String(camperRecord).trim().replace(/^"|"$/g, "");
  if (!raw || raw.toUpperCase() === "NONE") return raw;

  // Full URL already provided
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).toString();
    } catch (e) {
      return null;
    }
  }

  // Relative path contains uploads/camper/
  const marker = "uploads/camper/";
  const markerIndex = raw.toLowerCase().indexOf(marker);
  if (markerIndex >= 0) {
    const filename = raw.substring(markerIndex + marker.length).replace(/^\/+/, "");
    return filename ? `${HEALTH_FORM_BASE_URL}${encodeURIComponent(filename)}` : null;
  }

  // Filename-only fallback
  const filenameOnly = raw.split("/").pop();
  return filenameOnly ? `${HEALTH_FORM_BASE_URL}${encodeURIComponent(filenameOnly)}` : null;
};

function EncryptModal(props) {
  const { show, proceed, title, user_data } =
    props;

  const [isBusy, setIsBusy] = useState(false)
  useEffect(() => {
    setIsBusy(true);
    setTimeout(() => {
      setIsBusy(false);
      proceed(null);
      if (!user_data.camper_record) {
        message.error("Health form URL is missing or invalid.");
        return;
      }
      if (String(user_data.camper_record).trim().toUpperCase() === "NONE") {
        message.error("No health form available for this camper.");
        return;
      }

      const healthFormUrl = resolveHealthFormUrl(user_data.camper_record);
      if (!healthFormUrl || healthFormUrl.toUpperCase() === "NONE") {
        message.error("Health form URL is missing or invalid.");
        return;
      }

      window.open(healthFormUrl, '_blank', 'noopener,noreferrer');
    }, 2000);
  }, [])
  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="encrypt-dlg"
      closable={true}
      maskClosable={false}
      footer={null}
      okText="Ok"
      onOk={() => {
        proceed(null);
      }}
    >
      <div style={{textAlign: 'center'}}>
        <Spin spinning={isBusy} tip={title}></Spin>
      </div>
    </Modal>
  );
}

export default confirmable(EncryptModal);
